<app-back-button />

<h1>{{ 'admin.user-management.title' | translate }}</h1>

<app-user-management-table [users]="users()" />
